<template>
  <div class="search-result-panel">
    <div class="search-result__header">
      <span></span>
      <div class="search-result__header__action">
        <slot name="searchResultSlot"></slot>
      </div>
    </div>
    <!-- table 表格数据插槽 -->
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'SearchResultPanel',
}
</script>
<style scoped>
.search-result-panel {
  padding-bottom: 20px;
  background-color: #fff;
}
.search-result-panel .search-result__header {
  display: flex;
  height: 60px;
  font-size: 14px;
  padding-left: 10px;
  padding-right: 15px;
  align-items: center;
  justify-content: space-between;
}
.search-result__header__action >>> .ant-btn {
  margin-left: 10px;
  margin-bottom: 0 !important;
}
</style>
